import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import config from './modules/config'
import project from './modules/project'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    config,
    project
  },
  getters
})

export default store